import * as v from 'valibot';

const imageSizeSchema = v.object({
  width: v.number(),
  height: v.number(),
  url: v.string(),
});

const quizSchema = v.object({
  id: v.number(),
  name: v.string(),
  theme: v.number(),
  question: v.string(),
  answers: v.array(
    v.object({
      id: v.number(),
      text: v.string(),
    }),
  ),
  testPixel: v.string(),
  article: v.object({
    cover: v.nullable(
      v.object({
        height: v.number(),
        id: v.number(),
        sizes: v.record(v.string(), imageSizeSchema),
        url: v.string(),
        width: v.number(),
      }),
    ),
    default_cover: v.record(v.string(), imageSizeSchema),
    id: v.number(),
    title: v.string(),
    url: v.string(),
  }),
});

export const getQuickPollStatisticsSchema = v.object({
  data: v.object({
    clicks: v.record(v.string(), v.number()),
    id: v.number(),
    views: v.number(),
  }),

  success: v.boolean(),
});

export const getQuickPollSchema = v.object({
  data: v.object({
    id: v.number(),
    data: quizSchema,
  }),
  success: v.boolean(),
});
